import {lazy} from 'react';

export const RteTooltipLazy = lazy(() => import(/* webpackChunkName: "rteTooltip" */ '.'));
